// Core React Imports
import React from "react";

// Local Imports
import { usePageTerminalInfo } from "./usePageTerminalInfo";
import ConstantsImages from "../../constants/ConstantsImages";
import ConstantsTexts from "../../constants/ConstantsTexts";
import { DivColumn, DivRow, WidgetMarginWidth, WidgetMarginHeight, ParagraphText, InputTwo } from "../../styles/SharedStyles";
import WidgetTerminalInfoMap from "../../widgets/maps/widget-terminal-info-map/WidgetTerminalInfoMap";
import WidgetDropdown from "../../widgets/dropdowns/widget-dropdown/WidgetDropdown";
import WidgetInput from "../../widgets/inputs/widget-input/WidgetInput";
import WidgetTextViewData from "../../widgets/texts/WidgetTextViewData";
import WidgetAlertDialogEdit from "../../widgets/alert-dialogs/widget-alert-dialog-edit/WidgetAlertDialogEdit";
import WidgetAlertDialogFrozenTerminalBlocked from "../../widgets/alert-dialogs/widget-alert-dialog-frozen-terminal-blocked/WidgetAlertDialogFrozenTerminalBlocked";
import WidgetAlertDialogOpenChangeRequestBlocked from "../../widgets/alert-dialogs/widget-alert-dialog-open-change-request-blocked/WidgetAlertDialogOpenChangeRequestBlocked";
import WidgetAlertDialogSubjectiveChangeReason from "../../widgets/alert-dialogs/widget-alert-dialog-subjective-change-reason/WidgetAlertDialogSubjectiveChangeReason";
import WidgetAlertDialogSubjectiveChangeSuccess from "../../widgets/alert-dialogs/widget-alert-dialog-subjective-change-success/WidgetAlertDialogSubjectiveChangeSuccess";
import WidgetAlertDialogChangeRequestDetails from "../../widgets/alert-dialogs/widget-alert-dialog-change-request-details/WidgetAlertDialogChangeRequestDetails";
import WidgetUpdatesListGeneral from "../../widgets/shared_widgets/widget-updates-list-general/WidgetUpdatesListGeneral";
import WidgetIconTwo from "../../widgets/icons/widget-icon-two/WidgetIconTwo";
import WidgetIconThree from "../../widgets/icons/widget-icon-three/WidgetIconThree";
import WidgetModelVersionDropdown from "../../widgets/dropdowns/widget-model-version-dropdown/WidgetModelVersionDropdown";
import WidgetCheckbox from "../../widgets/checkboxes/WidgetCheckbox";
import WidgetGaugeUI from "../../widgets/shared_widgets/widget-gauge-ui/WidgetGaugeUI";
import UtilsUnit from "../../utils/UtilsUnit";
import WidgetModelIcon from "../../widgets/shared_widgets/widget-model-icon/WidgetModelIcon";
import WidgetDashboardIcon from "../../widgets/shared_widgets/widget-dashboard-icon/WidgetDashboardIcon";
import WidgetSmallTransportationTitle from "../../widgets/shared_widgets/widget-small-transportation-title/WidgetSmallTransportationTitle";
import WidgetSearchFrame from "../../widgets/shared_widgets/widget-search-frame/WidgetSearchFrame";
import WidgetChangelogFrame from "../../widgets/shared_widgets/widget-changelog-frame/WidgetChangelogFrame";
import WidgetFixedSizeList from "../../widgets/shared_widgets/widget-fixed-size-list/WidgetFixedSizeList";
import WidgetIconFive from "../../widgets/icons/widget-icon-five/WidgetIconFive";
import WidgetInputBase from "../../widgets/inputs/widget-input-base/WidgetInputBase";
import WidgetIcon from "../../widgets/icons/widget-icon/WidgetIcon";
import WidgetCreateTerminalIcon from "../../widgets/shared_widgets/widget-create-terminal-icon/WidgetCreateTerminalIcon";
import WidgetUsersIcon from "../../widgets/shared_widgets/widget-users-icon/WidgetUsersIcon";
import WidgetChangeRequestsIcon from "../../widgets/shared_widgets/widget-change-requests-icon/WidgetChangeRequestsIcon";
import WidgetRequiredLabel from "../../widgets/shared_widgets/widget-required-label/WidgetRequiredLabel";
import WidgetFrozenVersionBadge from "../../widgets/shared_widgets/widget-frozen-version-badge/WidgetFrozenVersionBadge";

// CSS/Stylesheets
import "./PageTerminalInfo.css";

function PageTerminalInfo() {
  const {
    dataIsReceived,
    editMode,
    createNewTerminalMode,
    colorEditMode,
    handleSearchTerminalIconClick,
    handleSetEditModeTrueClick,
    showUpdatesList,
    handleShowUpdatesListClick,
    changedTerminalID,
    nationalModelForTerminalData,
    terminalOwnership,
    municipalityPosition,
    terminalTypesAndPrices,
    handleSelectTerminalTypeName,
    selectedTerminalTypeName,
    handleSelectTerminalOwnership,
    selectedTerminalOwnership,
    handleSelectMunicipalityPositionPlace,
    selectedMunicipalityPositionPlace,
    nationalModelForTerminalCount,
    nationalModelForTerminalDistinctWorkneed,
    handleSelectWorkNeed,
    selectedWorkNeed,
    inputValueTerminalMakat,
    handleChangeTerminalMakat,
    inputValueTerminalMakatErez,
    handleChangeTerminalMakatErez,
    inputValueTerminalName,
    handleChangeTerminalName,
    inputValueRequiredTerminalSize,
    handleChangeRequiredTerminalSize,
    inputValueAreaInPlaningArea,
    handleChangeAreaInPlaningArea,
    inputValueAreaNeedForPlaningArea,
    handleChangeAreaNeedForPlaningArea,
    organizationInCharge,
    handleSelectOrganizationInChargeName,
    selectedOrganizationInChargeName,
    budgetStatus,
    handleSelectBudgetStatusName,
    selectedBudgetStatusName,
    terminalStatus,
    handleSelectTerminalStatusName,
    selectedTerminalStatusName,
    terminalStops,
    numbers1To5,
    handleSelectApplicability,
    selectedApplicability,
    getSecondaryMeasurePercentForDisplay,
    inputValueImportanceMeasure,
    handleChangeImportanceMeasure,
    inputValuePotentialMeasure,
    handleChangePotentialMeasure,
    numbers1To4,
    handleSelectRingByStrategicPlan,
    selectedRingByStrategicPlan,
    isDialogEditOpen,
    closeEditAlertDialog,
    getDialogEditMessageText,
    getDialogEditApproveText,
    getDialogEditCancelText,
    urgencyMeasure,
    handleSelectUrgencyMeasureValue,
    selectedUrgencyMeasureValue,
    inputValueComments,
    handleChangeComments,
    handleCancelTerminalChanges,
    uniqueDistricts,
    handleSelectDropdownDistrict,
    selectedDistrict,
    uniqueMunicipalities,
    handleSelectDropdownMunicipality,
    selectedMunicipality,
    uniqueTerminals,
    handleSelectDropdownTerminal,
    selectedTerminal,
    showSearchTerminal,
    busLinesMenuOpened,
    handleBusLinesMenuOpened,
    busLinesInTerminalChecked,
    handleBusLinesInTerminalChecked,
    busLinesInTerminalExpanded,
    handleBusLinesInTerminalExpanded,
    busLinesNearTerminalChecked,
    handleBusLinesNearTerminalChecked,
    busLinesNearTerminalExpanded,
    handleBusLinesNearTerminalExpanded,
    busLinesInTerminalItems,
    busLinesNearTerminalItems,
    handleTerminalItemCheck,
    handleNearTerminalItemCheck,
    getSelectedBusLinesData,
    userData,
    modelVersions,
    handleSelectModelVersion,
    selectedModelVersion,
    isTerminalVersionGreaterThanZeroAndEditModeFalse,
    isTerminalVersionGreaterThanZero,
    shouldShowSourceTerminalScore,
    shouldUseTerminalVersionComparisonColors,
    isCreatingOrEditingInitialVersion,
    shouldShowFieldsForNonInitialTerminalAndModelVersion,
    getTerminalRankArrowImage,
    getTerminalRankArrowImageSize,
    getTerminalRankColor,
    handleFormSubmit,
    shouldUseInitialVersionForManager,
    isEditorEditingInitialVersion,
    isTerminalVersionZero,
    isEditingExistingTerminal,
    shouldShowFieldsForGeneral,
    handlePolygonUploadClick,
    uploadedPolygon,
    handleDeleteTerminalClick,
    lastActionRef,
    handleClearTerminalType,
    handleClearTerminalOwnership,
    handleClearMunicipalityPosition,
    handleClearWorkNeed,
    handleClearUrgencyMeasure,
    handleClearOrganizationInCharge,
    handleClearBudgetStatus,
    handleClearTerminalStatus,
    handleClearApplicability,
    handleClearRingByStrategicPlan,
    isFrozenTerminalBlockedDialogOpen,
    closeFrozenTerminalBlockedDialog,
    showFrozenTerminalBlockedDialog,
    isSubjectiveChangeReasonDialogOpen,
    closeSubjectiveChangeReasonDialog,
    submitSubjectiveChangeRequest,
    isSubjectiveChangeSuccessDialogOpen,
    closeSubjectiveChangeSuccessDialog,
    getSubjectiveChangeSuccessMessage,
    subjectiveChangeSuccessKind,
    isOpenChangeRequestBlockedDialogOpen,
    closeOpenChangeRequestBlockedDialog,
    getOpenChangeRequestBlockedTerminalName,
    pendingChangeRequest,
    isPendingChangeRequestReview,
    getPendingUrgencyGaugePresentation,
    getPendingFeasibilityBefore,
    hasPendingFeasibilityChanged,
    hasPendingPointsChanged,
    hasPendingRankChanged,
    isChangeRequestDetailsOpen,
    openChangeRequestDetails,
    closeChangeRequestDetails,
    approvePendingChangeRequest,
    isApprovingChangeRequest,
    rejectPendingChangeRequest,
    isRejectingChangeRequest,
  } = usePageTerminalInfo();

  if (!dataIsReceived) {
    return <div />;
  }

  return body();

  function body() {
    return (
      <div className="page-terminal-info-container">
        <DivColumn style={{ width: "225rem" }}>
          <DivRow className="terminal-8-frame-2">
            {rightDesignUi()}
            <DivColumn as="form" onSubmit={handleFormSubmit}>
              <DivRow className="terminal-header-row">
                {terminalHeaderSection()}
                <WidgetMarginWidth width="1rem" />
                {terminalRankAndWorkNeedSection()}
              </DivRow>
              <WidgetMarginHeight height="1.1rem" />
              <DivRow className="terminal-5-frame">
                {terminalMetricsSection()}
                {terminalStatusSection()}
              </DivRow>
              <WidgetMarginHeight height="1.1rem" />
              {terminalCostsSection()}
              <WidgetMarginHeight height="1.9rem" />
              {commentsSection()}
            </DivColumn>
            {mapUi()}
          </DivRow>
        </DivColumn>
        {alertDialog()}
      </div>
    );
  }

  function rightDesignUi() {
    return (
      <DivColumn className="terminal-7-frame" style={{ minHeight: "90.4rem" }}>
        <WidgetSmallTransportationTitle />
        <WidgetMarginHeight height="1.7rem" />
        <WidgetSearchFrame
          showSearchTerminal={showSearchTerminal}
          handleSearchTerminalIconClick={handleSearchTerminalIconClick}
          uniqueDistricts={uniqueDistricts}
          uniqueMunicipalities={uniqueMunicipalities}
          uniqueTerminals={uniqueTerminals}
          selectedDistrict={selectedDistrict}
          selectedMunicipality={selectedMunicipality}
          selectedTerminal={selectedTerminal}
          handleSelectDropdownDistrict={handleSelectDropdownDistrict}
          handleSelectDropdownMunicipality={handleSelectDropdownMunicipality}
          handleSelectDropdownTerminal={handleSelectDropdownTerminal}
          editMode={editMode}
        />
        <WidgetMarginHeight height="0.5rem" />
        <WidgetModelIcon userData={userData} editMode={editMode} />
        <WidgetMarginHeight height="0.5rem" />
        <WidgetDashboardIcon editMode={editMode} />
        {UtilsUnit.managerUser(userData) && (
          <>
            <WidgetMarginHeight height="0.5rem" />
            <WidgetCreateTerminalIcon
              editMode={editMode}
              isCreateBlocked={!!selectedModelVersion?.isFrozen}
              onCreateBlocked={showFrozenTerminalBlockedDialog}
            />
          </>
        )}
        {UtilsUnit.managerUser(userData) && (
          <>
            <WidgetMarginHeight height="0.5rem" />
            <WidgetUsersIcon />
          </>
        )}
        {UtilsUnit.managerUser(userData) && (
          <>
            <WidgetMarginHeight height="0.5rem" />
            <WidgetChangeRequestsIcon />
          </>
        )}
        {!createNewTerminalMode && (
          <>
            <WidgetMarginHeight height="1.7rem" />
            <WidgetChangelogFrame showUpdatesList={showUpdatesList} handleShowUpdatesListClick={handleShowUpdatesListClick} updatesListGeneralUi={updatesListGeneralUi} />
          </>
        )}
      </DivColumn>
    );
  }

  function updatesListGeneralUi() {
    return <WidgetUpdatesListGeneral data={changedTerminalID} urgencyMeasure={urgencyMeasure} />;
  }

  function terminalHeaderSection() {
    const showSourceTerminalScore = shouldShowSourceTerminalScore();
    const useVersionComparisonColors = shouldUseTerminalVersionComparisonColors();
    const sourceTerminalPoints =
      nationalModelForTerminalData?.fatherTerminalPoints ?? pendingChangeRequest?.pointsBefore ?? null;

    return (
      <div
        className="terminal-frame"
        style={{
          background: editMode ? "#363853" : "#393939",
        }}
      >
        <DivColumn className="terminal-frame-1">
          {terminalHeaderContent()}
          {terminalHeaderFooter()}
        </DivColumn>
        {!editMode && (
          <DivColumn className={`terminal-frame-inner-3${showSourceTerminalScore ? " terminal-frame-inner-3-stacked" : ""}`}>
            {terminalHeaderRank({
              widthProp: "10.7rem",
              title: showSourceTerminalScore ? "ניקוד מסוף" : ConstantsTexts.CODE_29,
              backgroundColor: "rgba(89, 93, 112, 0.63)",
              points: nationalModelForTerminalData.totalPoints,
              textColor: useVersionComparisonColors ? getTerminalRankColor() : "#49dabf",
              pointsFontWeight: "700",
              pointsFontSize: showSourceTerminalScore ? "3rem" : "3.3rem",
              titleFontSize: showSourceTerminalScore ? "1.2rem" : "1.6rem",
              titleLineHeight: showSourceTerminalScore ? "1.2rem" : "1.6rem",
              gap: "0.2rem",
              marginTop: "0rem",
              padding: showSourceTerminalScore ? "1.4rem 0.3rem" : "0.8rem",
              highlight: hasPendingPointsChanged(),
              showPersonIcon: showSourceTerminalScore || hasPendingPointsChanged(),
              classNameProp: showSourceTerminalScore ? "terminal-frame-inner-stacked-top" : "",
            })}
            {showSourceTerminalScore &&
              terminalHeaderRank({
                widthProp: "10.7rem",
                title: ConstantsTexts.CODE_156,
                backgroundColor: "rgba(89, 93, 112, 0.3)",
                points: sourceTerminalPoints,
                textColor: "#92a69d",
                pointsFontWeight: "800",
                pointsFontSize: "1.6rem",
                titleFontSize: "1.2rem",
                titleLineHeight: "1.4rem",
                gap: "0.2rem",
                padding: "0.5rem 0.3rem",
                classNameProp: "terminal-frame-inner-stacked-bottom",
              })}
          </DivColumn>
        )}
      </div>
    );
  }

  function terminalHeaderContent() {
    return (
      <DivRow className="terminal-frame-2">
        <WidgetIconFive iconProp={ConstantsImages.BUS_STATION_IMAGE} widthIconProp="7.7rem" heightIconProp="6.5rem" />
        <DivRow className="terminal-frame-3">
          {editMode
            ? terminalCancelEditButton()
            : selectedModelVersion?.isFrozen
              ? <WidgetFrozenVersionBadge variant="onDark" />
              : !isPendingChangeRequestReview() && terminalEditButton()}
          {isPendingChangeRequestReview() && terminalChangeRequestButton()}
          {createNewTerminalMode
            ? terminalTopInputsHeader()
            : nationalModelForTerminalData && (
                <DivColumn className="terminal-frame-4">
                  <ParagraphText className="terminal-text-1">{nationalModelForTerminalData.terminalName}</ParagraphText>
                  <ParagraphText className="terminal-text-2">{nationalModelForTerminalData.erezSKU}</ParagraphText>
                </DivColumn>
              )}
        </DivRow>
      </DivRow>
    );
  }

  function terminalChangeRequestButton() {
    return (
      <WidgetIconTwo
        iconProp={ConstantsImages.REQUEST_DETAILS_IMAGE}
        textProp={ConstantsTexts.CODE_273}
        widthProp="6.2rem"
        heightProp="6.6rem"
        backgroundColorProp="#f5a623"
        textColorProp="#fff"
        textFontWeightProp="700"
        textFontSizeProp="1.2rem"
        widthIconProp="2rem"
        heightIconProp="2rem"
        gapProp="0.4rem"
        handleOnClickProp={openChangeRequestDetails}
      />
    );
  }

  function terminalCancelEditButton() {
    return (
      <WidgetIcon
        iconProp={ConstantsImages.BACK_IMAGE}
        backgroundColorProp="#00000021"
        widthProp="6.2rem"
        heightProp="6.6rem"
        widthIconProp="1.6rem"
        heightIconProp="1.6rem"
        handleOnClickProp={handleCancelTerminalChanges}
      />
    );
  }

  // Renders edit button with conditional visibility based on user permissions and terminal version
  function terminalEditButton() {
    const canEdit = UtilsUnit.editorUserAbove(userData);

    return (
      <div style={{ width: "6.2rem" }}>
        {canEdit ? (
          <WidgetIconTwo
            iconProp={ConstantsImages.EDIT_IMAGE}
            textProp={ConstantsTexts.CODE_117}
            widthProp="6.2rem"
            backgroundColorProp="#fff"
            widthIconProp="2.4rem"
            heightIconProp="2.3rem"
            gapProp="0.7rem"
            handleOnClickProp={handleSetEditModeTrueClick}
            customClassNameProp="widget-edit-icon"
          />
        ) : (
          <div />
        )}
      </div>
    );
  }

  function terminalHeaderFooter() {
    return (
      <DivRow className="terminal-frame-5">
        <WidgetModelVersionDropdown
          options={modelVersions}
          onSelect={handleSelectModelVersion}
          selectedOptionProp={selectedModelVersion}
          disabled={editMode && !createNewTerminalMode}
          backgroundColorProp="#212121"
        />
        <WidgetMarginWidth width={editMode ? "0.5rem" : "3rem"} />
        {editMode ? terminalTypeDropdown() : terminalTypeDisplay()}
        <WidgetMarginWidth width={editMode ? "0.5rem" : "1rem"} />
        {isCreatingOrEditingInitialVersion() ? terminalMunicipalityDropdown() : terminalMunicipalityDisplay()}
        {!editMode && !createNewTerminalMode && isTerminalVersionZero() && terminalMunicipality2040Display()}
        {isCreatingOrEditingInitialVersion() && terminalOwnershipDropdown()}
        {createNewTerminalMode && terminalFileUploadButton()}
      </DivRow>
    );
  }

  function terminalTopInputsHeader() {
    return (
      <DivRow className="terminal-2-frame-4">
        <WidgetInput
          label={ConstantsTexts.CODE_180}
          value={inputValueTerminalMakat}
          onChange={handleChangeTerminalMakat}
          heightProp="6.2rem"
          widthProp="11.8rem"
          titleColorProp="#fff"
          backgoundColortProp="#F0F1F54D"
          textColorProp="#fff"
          disabled={isEditorEditingInitialVersion()}
          isRequiredUI={createNewTerminalMode}
          required={!isEditorEditingInitialVersion()}
        />
        <WidgetInput
          label={ConstantsTexts.CODE_183}
          value={inputValueTerminalMakatErez}
          onChange={handleChangeTerminalMakatErez}
          heightProp="6.2rem"
          widthProp="11.8rem"
          titleColorProp="#fff"
          backgoundColortProp="#F0F1F54D"
          textColorProp="#fff"
          disabled={isEditorEditingInitialVersion()}
          isRequiredUI={createNewTerminalMode}
          required={!isEditorEditingInitialVersion()}
        />
        <WidgetInput
          label={ConstantsTexts.CODE_184}
          value={inputValueTerminalName}
          onChange={handleChangeTerminalName}
          heightProp="6.2rem"
          widthProp="18.7rem"
          titleColorProp="#fff"
          backgoundColortProp="#F0F1F54D"
          textColorProp="#fff"
          fontFamilyInputProp="Almoni DL AAA"
          disabled={isEditorEditingInitialVersion()}
          isRequiredUI={createNewTerminalMode}
          required={!isEditorEditingInitialVersion()}
        />
      </DivRow>
    );
  }

  function terminalTypeDropdown() {
    return (
      <DivRow>
        <WidgetDropdown
          options={terminalTypesAndPrices}
          labelKey="terminalTypeName"
          title={ConstantsTexts.CODE_68}
          onSelect={handleSelectTerminalTypeName}
          selectedOptionProp={selectedTerminalTypeName}
          heightProp="6.2rem"
          widthProp={createNewTerminalMode ? "11.8rem" : "13.9rem"}
          backgroundColorProp="#F0F1F54D"
          titleColorProp="#fff"
          textColorProp="#fff"
          arrowImage={ConstantsImages.ARROW_WHITE_IMAGE}
          borderRadiusProp="1rem"
          fontSizeTitle="1.2rem"
          disabled={isEditorEditingInitialVersion() || isEditingExistingTerminal()}
          enableClear={true}
          onClear={handleClearTerminalType}
          isRequiredUI={createNewTerminalMode}
        />
      </DivRow>
    );
  }

  function terminalTypeDisplay() {
    return (
      <DivRow style={{ alignItems: "flex-end" }}>
        <WidgetIconFive iconProp={ConstantsImages.TERMINAL_TYPE_IMAGE} widthIconProp="1.5rem" heightIconProp="1.4rem" />
        <WidgetMarginWidth width="0.5rem" />
        <DivColumn>
          <ParagraphText className="terminal-text-42">{ConstantsTexts.CODE_144}</ParagraphText>
          <ParagraphText className="terminal-text-3">{nationalModelForTerminalData.terminalType}</ParagraphText>
        </DivColumn>
      </DivRow>
    );
  }

  function terminalMunicipalityDropdown() {
    return (
      <DivRow>
        <WidgetDropdown
          options={municipalityPosition}
          labelKey="municipalityName"
          title={ConstantsTexts.CODE_179}
          onSelect={handleSelectMunicipalityPositionPlace}
          selectedOptionProp={selectedMunicipalityPositionPlace}
          heightProp="6.2rem"
          widthProp={createNewTerminalMode ? "11.8rem" : "13.9rem"}
          backgroundColorProp="#F0F1F54D"
          titleColorProp="#fff"
          textColorProp="#fff"
          arrowImage={ConstantsImages.ARROW_WHITE_IMAGE}
          borderRadiusProp="1rem"
          fontSizeTitle="1.2rem"
          disabled={isEditorEditingInitialVersion() || isEditingExistingTerminal()}
          enableSearch={true}
          enableClear={true}
          onClear={handleClearMunicipalityPosition}
          isRequiredUI={createNewTerminalMode}
        />
      </DivRow>
    );
  }

  function terminalMunicipalityDisplay() {
    return (
      <DivRow style={{ alignItems: "flex-end" }}>
        <WidgetIconFive iconProp={ConstantsImages.MARKER_IMAGE} widthIconProp="1.4rem" heightIconProp="1.4rem" /> {/* 1.2rem x 1.4rem */}
        <WidgetMarginWidth width="0.5rem" />
        <DivColumn>
          <ParagraphText className="terminal-text-42">{ConstantsTexts.CODE_179}</ParagraphText>
          <ParagraphText className="terminal-text-3">{nationalModelForTerminalData.municipalityName}</ParagraphText>
        </DivColumn>
      </DivRow>
    );
  }

  function terminalMunicipality2040Display() {
    return (
      <DivRow style={{ alignItems: "flex-end" }}>
        <WidgetMarginWidth width="1rem" />
        <WidgetIconFive iconProp={ConstantsImages.MARKER_IMAGE} widthIconProp="1.4rem" heightIconProp="1.4rem" /> {/* 1.2rem x 1.4rem */}
        <WidgetMarginWidth width="0.5rem" />
        <DivColumn>
          <ParagraphText className="terminal-text-42">{ConstantsTexts.CODE_237}</ParagraphText>
          <ParagraphText className="terminal-text-3">{nationalModelForTerminalData.muni2040Name}</ParagraphText>
        </DivColumn>
      </DivRow>
    );
  }

  function terminalOwnershipDropdown() {
    return (
      <DivRow>
        <WidgetMarginWidth width="0.5rem" />
        <WidgetDropdown
          options={terminalOwnership}
          labelKey="terminalOwnershipName"
          title={ConstantsTexts.CODE_125}
          onSelect={handleSelectTerminalOwnership}
          selectedOptionProp={selectedTerminalOwnership}
          heightProp="6.2rem"
          widthProp={createNewTerminalMode ? "11.8rem" : "13.9rem"}
          backgroundColorProp="#F0F1F54D"
          titleColorProp="#fff"
          textColorProp="#fff"
          arrowImage={ConstantsImages.ARROW_WHITE_IMAGE}
          borderRadiusProp="1rem"
          fontSizeTitle="1.2rem"
          disabled={isEditorEditingInitialVersion() || isEditingExistingTerminal()}
          enableClear={true}
          onClear={handleClearTerminalOwnership}
        />
      </DivRow>
    );
  }

  function terminalFileUploadButton() {
    return (
      <DivRow>
        <WidgetMarginWidth width="0.7rem" />
        <WidgetIconTwo
          iconProp={ConstantsImages.POLYGON_IMAGE}
          backgroundColorProp="#5051A1"
          widthProp="6.3rem"
          heightProp="6.2rem"
          widthIconProp="1.7rem"
          heightIconProp="1.6rem"
          textProp={ConstantsTexts.CODE_185}
          textColorProp="#fff"
          textFontWeightProp="900"
          handleOnClickProp={handlePolygonUploadClick}
        />
      </DivRow>
    );
  }

  // Renders terminal rank display with customizable styling and layout
  function terminalHeaderRank({
    widthProp,
    backgroundColor,
    title,
    points,
    textColor,
    pointsFontWeight,
    pointsFontSize = "3.3rem",
    titleFontSize = "1.6rem",
    titleLineHeight = "1.6rem",
    gap = "0.5rem",
    marginTop = "0rem",
    padding = "0.8rem",
    highlight = false,
    showPersonIcon = false,
    classNameProp = "",
  }) {
    return (
      <div
        className={`terminal-frame-inner${highlight ? " terminal-change-highlight" : ""}${classNameProp ? ` ${classNameProp}` : ""}`}
        style={{ width: widthProp, backgroundColor, padding }}
      >
        <div className="terminal-frame-inner-2">
          <DivColumn style={{ alignItems: "center", gap: "0.4rem" }}>
            {showPersonIcon && (
              <WidgetIconFive
                iconProp={ConstantsImages.TERMINAL_SCORE_PERSON_IMAGE}
                widthIconProp="1.3rem"
                heightIconProp="1.3rem"
              />
            )}
            <DivColumn>
              <ParagraphText
                className="terminal-text-4"
                style={{ color: textColor, marginTop, lineHeight: titleLineHeight, fontSize: titleFontSize, width: "100%" }}
              >
                {title}
              </ParagraphText>
              <WidgetMarginHeight height={gap} />
              <ParagraphText
                className="terminal-text-5"
                style={{ color: textColor, fontWeight: pointsFontWeight, fontSize: pointsFontSize, lineHeight: pointsFontSize === "3rem" ? "2.4rem" : pointsFontSize }}
              >
                {points}
              </ParagraphText>
            </DivColumn>
          </DivColumn>
        </div>
      </div>
    );
  }

  function terminalRankAndHandle() {
    return editMode ? terminalSaveAndDeleteButtons() : terminalRankDisplay();
  }

  function terminalSaveAndDeleteButtons() {
    return (
      <DivRow className="terminal-2-frame-3" style={{ height: "11.8rem" }}>
        {shouldUseInitialVersionForManager() && (
          <WidgetIconTwo
            iconProp={ConstantsImages.DELETE_IMAGE}
            backgroundColorProp="#DBDDE2"
            borderProp="1px solid #727272"
            widthProp="8rem"
            heightProp="9.3rem"
            widthIconProp="1.8rem"
            heightIconProp="2.1rem"
            textProp={ConstantsTexts.CODE_177}
            textFontWeightProp="900"
            textFontSizeProp="1.4rem"
            handleOnClickProp={handleDeleteTerminalClick}
          />
        )}
        <WidgetIconTwo
          iconProp={ConstantsImages.CHECK_WHITE_IMAGE}
          backgroundColorProp="#2E2E2E"
          widthProp={shouldUseInitialVersionForManager() ? "16.7rem" : "25rem"}
          heightProp="9.5rem"
          widthIconProp="1.6rem"
          heightIconProp="1.3rem"
          textProp={createNewTerminalMode ? ConstantsTexts.CODE_182 : ConstantsTexts.CODE_178}
          textColorProp="#fff"
          textFontWeightProp="900"
          textFontSizeProp="1.4rem"
          buttonType={"submit"}
        />
      </DivRow>
    );
  }

  function terminalRankDisplay() {
    const useVersionComparisonColors = shouldUseTerminalVersionComparisonColors();

    return (
      <DivRow
        className={`terminal-2-frame${hasPendingRankChanged() ? " terminal-change-highlight" : ""}`}
        style={{ width: "25rem" }}
      >
        <WidgetIconFive iconProp={editMode ? ConstantsImages.TERMINAL_RANK_GRAY_IMAGE : ConstantsImages.TERMINAL_RANK_IMAGE} widthIconProp="5.8rem" heightIconProp="5.8rem" />
        <WidgetMarginWidth width="2.3rem" />
        <DivColumn>
          <DivRow className="terminal-2-frame-2">
            {useVersionComparisonColors && (
              <>
                <ParagraphText className="terminal-text-41">{nationalModelForTerminalData.fatherTerminalRank}</ParagraphText>
                <WidgetIconFive iconProp={getTerminalRankArrowImage()} {...getTerminalRankArrowImageSize()} />
              </>
            )}
            <ParagraphText
              className="terminal-text-6"
              style={{ color: useVersionComparisonColors ? getTerminalRankColor() : editMode ? "#9CA4CA" : "#FFFFFF" }}
            >
              {nationalModelForTerminalData.terminalRank}
            </ParagraphText>
          </DivRow>
          <ParagraphText
            className="terminal-text-7"
            style={{ color: useVersionComparisonColors ? getTerminalRankColor() : editMode ? "#9CA4CA" : "#FFFFFF" }}
          >
            /{nationalModelForTerminalCount.count}
          </ParagraphText>
        </DivColumn>
      </DivRow>
    );
  }

  function terminalWorkNeedSection() {
    return (
      <DivRow
        className="terminal-3-frame"
        style={{
          height: "7.3rem",
          width: "25rem",
          padding: editMode ? "0.8rem 1rem" : "0.8rem 2rem",
        }}
      >
        {editMode ? terminalWorkNeedEdit() : terminalWorkNeedDisplay()}
      </DivRow>
    );
  }

  function terminalRankAndWorkNeedSection() {
    return (
      <DivColumn className="terminal-rank-and-workneed">
        {terminalRankAndHandle()}
        <WidgetMarginHeight height="0.3rem" />
        {terminalWorkNeedSection()}
      </DivColumn>
    );
  }

  function terminalWorkNeedEdit() {
    return (
      <DivRow
        style={{
          gap: "0.5rem",
          width: "25rem",
          display: "flex",
        }}
      >
        <WidgetDropdown
          options={nationalModelForTerminalDistinctWorkneed}
          labelKey="terminalNewStatusNameInNmft"
          title={ConstantsTexts.CODE_69}
          onSelect={handleSelectWorkNeed}
          selectedOptionProp={selectedWorkNeed}
          heightProp="5.3rem"
          widthProp="100%"
          titleColorProp="#2B3361"
          textColorProp="#2B3361"
          backgroundColorProp="#f0f1f580"
          arrowImage={ConstantsImages.ARROW_SMALL_IMAGE}
          style={{ flex: 1 }}
          borderRadiusProp="1rem"
          fontSizeTitle="1.2rem"
          disabled={shouldShowFieldsForGeneral() || isEditingExistingTerminal()}
          enableClear={true}
          onClear={handleClearWorkNeed}
          isRequiredUI={createNewTerminalMode}
        />
        <DivRow className="terminal-9-frame" style={{ flex: 1 }}>
          <div className="terminal-9-frame-2">
            <DivColumn className="terminal-9-frame-3">
              <WidgetRequiredLabel isRequired={createNewTerminalMode}>
                <ParagraphText className="terminal-text-28">{ConstantsTexts.CODE_30}</ParagraphText>
              </WidgetRequiredLabel>
              <WidgetInputBase
                value={UtilsUnit.formatNumberWithCommas(inputValueRequiredTerminalSize)}
                onChange={handleChangeRequiredTerminalSize}
                disabled={isEditorEditingInitialVersion() || isEditingExistingTerminal()}
                required={!isEditorEditingInitialVersion()}
              />
            </DivColumn>
          </div>
        </DivRow>
      </DivRow>
    );
  }

  function terminalWorkNeedDisplay() {
    return (
      <>
        <DivRow className="terminal-3-frame-2" style={{ width: "8.6rem" }}>
          <WidgetIconFive iconProp={ConstantsImages.CONE_IMAGE} widthIconProp="2.3rem" heightIconProp="2.1rem" />
          <DivColumn>
            <ParagraphText className="terminal-text-8">{ConstantsTexts.CODE_69}</ParagraphText>
            <ParagraphText className="terminal-text-9">{nationalModelForTerminalData.terminalsNewStatus}</ParagraphText>
          </DivColumn>
        </DivRow>
        <DivColumn className="terminal-3-frame-3">
          <ParagraphText className="terminal-text-8">{ConstantsTexts.CODE_30}</ParagraphText>
          <DivRow className="terminal-3-frame-5">
            <ParagraphText className="terminal-text-10">{UtilsUnit.formatNumberWithCommas(nationalModelForTerminalData.sizeNeededForTerminalInAcre)}</ParagraphText>
            <ParagraphText className="terminal-text-11">{ConstantsTexts.CODE_32}</ParagraphText>
          </DivRow>
        </DivColumn>
      </>
    );
  }

  function terminalMetricsSection() {
    return (
      <DivColumn className="terminal-4-frame">
        <DivRow className="terminal-4-frame-2">
          <WidgetIconFive iconProp={ConstantsImages.CAR_IMAGE} widthIconProp="2.0rem" heightIconProp="1.5rem" />
          <ParagraphText className="terminal-text-12">{ConstantsTexts.CODE_4}</ParagraphText>
        </DivRow>
        <DivColumn className="terminal-4-frame-3">
          <DivRow className="terminal-4-frame-4">{editMode ? terminalMetricsEdit() : terminalMetricsDisplay()}</DivRow>
          <DivColumn className="terminal-4-frame-12">
            <GaugeUI
              numberText={nationalModelForTerminalData.operationalGapsMeasure}
              label={ConstantsTexts.CODE_23}
              percentLabel={getSecondaryMeasurePercentForDisplay(4)}
              widthTexts="53.6rem"
            />
            <DivRow className="terminal-4-frame-11">
              {editMode ? terminal_area_edit() : terminal_area_display()}
              <WidgetTextViewData
                title={
                  <>
                    <span>{ConstantsTexts.CODE_42}</span>
                    <br />
                    <span>{ConstantsTexts.CODE_43}</span>
                  </>
                }
                text={UtilsUnit.formatNumberWithCommas(nationalModelForTerminalData.planedAreaDifference)}
                heightProp="5.3rem"
                widthProp="15.5rem"
                colorProp={colorEditMode}
              />
              <WidgetTextViewData
                title={
                  <>
                    <span>{ConstantsTexts.CODE_44}</span>
                    <br />
                    <span>{ConstantsTexts.CODE_45}</span>
                  </>
                }
                text={UtilsUnit.formatNumberWithPercent(nationalModelForTerminalData.ratioBetweenSizeNeededForTerminalAndPlanedAreaDifference)}
                heightProp="5.3rem"
                widthProp="19.7rem"
                colorProp={colorEditMode}
              />
            </DivRow>
          </DivColumn>
        </DivColumn>
      </DivColumn>
    );
  }

  function terminalMetricsEdit() {
    return (
      <>
        <DivColumn className="terminal-4-frame-5">
          <GaugeUI numberText={nationalModelForTerminalData.urgencyMeasure} label={ConstantsTexts.CODE_17} percentLabel={getSecondaryMeasurePercentForDisplay(1)} />
          <div className="terminal-4-frame-13" style={{ height: "4.9rem", width: "21.83rem" }}>
            <WidgetDropdown
              options={urgencyMeasure}
              labelKey="urgencyMeasureValue"
              title={ConstantsTexts.CODE_35}
              onSelect={handleSelectUrgencyMeasureValue}
              selectedOptionProp={selectedUrgencyMeasureValue}
              heightProp="4.4rem"
              widthProp="auto"
              backgroundColorProp="#E9EAEE"
              titleColorProp="#5A81FA"
              textColorProp="#2B308B"
              fontFamilyText="Heebo"
              fontFamilyOption="Heebo"
              arrowImage={ConstantsImages.ARROW_SMALL_IMAGE}
              borderRadiusProp="1rem"
              fontSizeTitle="1.2rem"
              disabled={shouldShowFieldsForNonInitialTerminalAndModelVersion()}
              enableClear={true}
              onClear={handleClearUrgencyMeasure}
              isRequiredUI={createNewTerminalMode}
            />
          </div>
        </DivColumn>
        <DivColumn className="terminal-4-frame-5">
          <GaugeUI numberText={nationalModelForTerminalData.importanceMeasure} label={ConstantsTexts.CODE_39} percentLabel={getSecondaryMeasurePercentForDisplay(2)} />
          <div className="terminal-4-frame-13" style={{ height: "4.9rem", width: "21.83rem" }}>
            <WidgetInput
              label={ConstantsTexts.CODE_40}
              value={UtilsUnit.formatNumberWithCommas(inputValueImportanceMeasure)}
              onChange={handleChangeImportanceMeasure}
              disabled={isEditorEditingInitialVersion() || isEditingExistingTerminal()}
              isRequiredUI={createNewTerminalMode}
              required={!isEditorEditingInitialVersion()}
            />
          </div>
        </DivColumn>
        <DivColumn className="terminal-4-frame-5">
          <GaugeUI numberText={nationalModelForTerminalData.potentialMeasure} label={ConstantsTexts.CODE_21} percentLabel={getSecondaryMeasurePercentForDisplay(3)} />
          <div className="terminal-4-frame-13" style={{ height: "4.9rem", width: "21.83rem" }}>
            <WidgetInput
              label={ConstantsTexts.CODE_41}
              value={UtilsUnit.formatNumberWithCommas(inputValuePotentialMeasure)}
              onChange={handleChangePotentialMeasure}
              disabled={isEditorEditingInitialVersion() || isEditingExistingTerminal()}
              isRequiredUI={createNewTerminalMode}
              required={!isEditorEditingInitialVersion()}
            />
          </div>
        </DivColumn>
      </>
    );
  }

  function terminalMetricsDisplay() {
    const urgencyGauge = getPendingUrgencyGaugePresentation();

    return (
      <>
        <GaugeTerminalUI
          numberText={urgencyGauge.numberText}
          terminalLabel={ConstantsTexts.CODE_17}
          terminalPercentLabel={getSecondaryMeasurePercentForDisplay(1)}
          gaugeTitle={ConstantsTexts.CODE_35}
          gaugeText={nationalModelForTerminalData.yearOfNeedGrade}
          fontFamilyProp="Heebo"
          previousValue={urgencyGauge.previousValue}
          highlight={urgencyGauge.highlight}
          showPreviousWhenSet={urgencyGauge.highlight && urgencyGauge.previousValue != null}
        />
        <GaugeTerminalUI
          numberText={nationalModelForTerminalData.importanceMeasure}
          terminalLabel={ConstantsTexts.CODE_39}
          terminalPercentLabel={getSecondaryMeasurePercentForDisplay(2)}
          gaugeTitle={ConstantsTexts.CODE_40}
          gaugeText={UtilsUnit.formatNumberWithCommas(nationalModelForTerminalData.numberOfTerminalsInArea)}
        />
        <GaugeTerminalUI
          numberText={nationalModelForTerminalData.potentialMeasure}
          terminalLabel={ConstantsTexts.CODE_21}
          terminalPercentLabel={getSecondaryMeasurePercentForDisplay(3)}
          gaugeTitle={ConstantsTexts.CODE_41}
          gaugeText={UtilsUnit.formatNumberWithCommas(nationalModelForTerminalData.populationDensity2040)}
        />
      </>
    );
  }

  function terminal_area_edit() {
    return (
      <>
        <div className="terminal-4-frame-13" style={{ height: "5.3rem", width: "15.46rem" }}>
          <WidgetInput
            label={ConstantsTexts.CODE_71}
            value={UtilsUnit.formatNumberWithCommas(inputValueAreaInPlaningArea)}
            onChange={handleChangeAreaInPlaningArea}
            disabled={isEditorEditingInitialVersion() || isEditingExistingTerminal()}
            isRequiredUI={createNewTerminalMode}
            required={!isEditorEditingInitialVersion()}
          />
        </div>
        <div className="terminal-4-frame-13" style={{ height: "5.3rem", width: "15.46rem" }}>
          <WidgetInput
            label={ConstantsTexts.CODE_72}
            value={UtilsUnit.formatNumberWithCommas(inputValueAreaNeedForPlaningArea)}
            onChange={handleChangeAreaNeedForPlaningArea}
            disabled={isEditorEditingInitialVersion() || isEditingExistingTerminal()}
            isRequiredUI={createNewTerminalMode}
            required={!isEditorEditingInitialVersion()}
          />
        </div>
      </>
    );
  }

  function terminal_area_display() {
    return (
      <>
        <WidgetTextViewData
          title={
            <>
              <span>{ConstantsTexts.CODE_46}</span>
              <br />
              <span>{ConstantsTexts.CODE_47}</span>
            </>
          }
          text={UtilsUnit.formatNumberWithCommas(nationalModelForTerminalData.areaInPlaningArea)}
          heightProp="5.3rem"
          widthProp="15.5rem"
          colorProp={colorEditMode}
        />
        <WidgetTextViewDataTerminalInfo
          title={
            <>
              <span>{ConstantsTexts.CODE_48}</span>
              <br />
              <span>{ConstantsTexts.CODE_47}</span>
            </>
          }
          text={UtilsUnit.formatNumberWithCommas(nationalModelForTerminalData.areaNeedForPlaningArea)}
          heightProp="5.3rem"
          widthProp="15.5rem"
        />
      </>
    );
  }

  function terminalStatusSection() {
    return (
      <DivColumn className="terminal-5-frame-2">
        <DivColumn className="terminal-5-frame-3" style={{ padding: editMode ? "1rem 2rem" : "1rem 3rem", gap: editMode ? "0.8rem" : "1.5rem" }}>
          {terminalStatusContent()}
        </DivColumn>
        <DivColumn className="terminal-5-frame-7">
          <DivColumn className="terminal-5-frame-8">
            <DivRow className="terminal-4-frame-2">
              <WidgetIconFive iconProp={ConstantsImages.SECTION_HEADER_IMAGE} widthIconProp="2.1rem" heightIconProp="2.1rem" />
              <ParagraphText className="terminal-text-12">{ConstantsTexts.CODE_8}</ParagraphText>
            </DivRow>
          </DivColumn>
          {editMode ? terminalApplicabilityEdit() : terminalApplicabilityDisplay()}
          <DivColumn className="terminal-4-frame-9">
            <ParagraphText className="terminal-text-19">{ConstantsTexts.CODE_36}</ParagraphText>
          </DivColumn>
        </DivColumn>
      </DivColumn>
    );
  }

  function terminalStatusContent() {
    return (
      <>
        {editMode ? (
          <WidgetTeminalFrame4DropdownItem
            optionsProp={organizationInCharge}
            labelKeyProp="organizationInChargeName"
            titleProp={ConstantsTexts.CODE_123}
            onSelectProp={handleSelectOrganizationInChargeName}
            selectedOptionProp={selectedOrganizationInChargeName}
            onClearProp={handleClearOrganizationInCharge}
          />
        ) : (
          <WidgetTeminalFrame4Item image={ConstantsImages.ORGANIZATION_IMAGE} text={nationalModelForTerminalData.organizationInCharge} widthProp="1.6rem" heightProp="1.9rem" />
        )}
        {editMode ? (
          <WidgetTeminalFrame4DropdownItem
            optionsProp={budgetStatus}
            labelKeyProp="budgetStatusName"
            titleProp={ConstantsTexts.CODE_124}
            onSelectProp={handleSelectBudgetStatusName}
            selectedOptionProp={selectedBudgetStatusName}
            onClearProp={handleClearBudgetStatus}
          />
        ) : (
          <WidgetTeminalFrame4Item image={ConstantsImages.COINS_TWO_IMAGE} text={nationalModelForTerminalData.budgetStatus} widthProp="1.8rem" heightProp="1.9rem" />
        )}
        {!createNewTerminalMode && (
          <WidgetTeminalFrame4Item
            image={ConstantsImages.LAST_UPDATED_IMAGE}
            text={UtilsUnit.formatDate(nationalModelForTerminalData.lastDateUpdated)}
            widthProp="1.6rem"
            heightProp="2.1rem"
          />
        )}
        {editMode ? (
          <WidgetTeminalFrame4DropdownItem
            optionsProp={terminalStatus}
            labelKeyProp="terminalStatusName"
            titleProp={ConstantsTexts.CODE_69}
            onSelectProp={handleSelectTerminalStatusName}
            selectedOptionProp={selectedTerminalStatusName}
            onClearProp={handleClearTerminalStatus}
          />
        ) : (
          <WidgetTeminalFrame4Item image={ConstantsImages.TERMINAL_STATUS_IMAGE} text={nationalModelForTerminalData.terminalStatus} widthProp="2.2rem" heightProp="1.2rem" />
        )}
      </>
    );
  }

  function WidgetTeminalFrame4DropdownItem({ optionsProp, labelKeyProp, titleProp, onSelectProp, selectedOptionProp, onClearProp }) {
    return (
      <WidgetDropdown
        options={optionsProp}
        labelKey={labelKeyProp}
        title={titleProp}
        onSelect={onSelectProp}
        selectedOptionProp={selectedOptionProp}
        heightProp="4.2rem"
        backgroundColorProp="#F0F1F533"
        titleColorProp="#fff"
        textColorProp="#fff"
        arrowImage={ConstantsImages.ARROW_WHITE_IMAGE}
        borderRadiusProp="1rem"
        fontSizeTitle="1.2rem"
        disabled={shouldShowFieldsForGeneral()}
        enableClear={true}
        onClear={onClearProp}
      />
    );
  }

  function WidgetTeminalFrame4Item({ image, text, widthProp, heightProp }) {
    return (
      <DivRow className="terminal-5-frame-4" style={{ padding: editMode ? "0rem 1rem" : "0rem 0rem" }}>
        <div className="terminal-5-frame-5">
          <WidgetIconFive iconProp={image} widthIconProp={widthProp} heightIconProp={heightProp} />
        </div>
        <ParagraphText className="terminal-text-34">{text}</ParagraphText>
      </DivRow>
    );
  }

  function terminalApplicabilityEdit() {
    return (
      <>
        <DivRow className="terminal-4-frame-6">
          <WidgetDropdown
            options={numbers1To5}
            labelKey="number"
            onSelect={handleSelectApplicability}
            selectedOptionProp={selectedApplicability}
            heightProp="5.2rem"
            widthProp="5.2rem"
            backgroundColorProp="#333"
            textColorProp="#fff"
            arrowImage={ConstantsImages.ARROW_WHITE_IMAGE}
            fontSizeText="1.5rem"
            fontFamilyText="Montserrat"
            fontWeightText="700"
            borderRadiusProp="1.5rem"
            enableClear={true}
            onClear={handleClearApplicability}
            isRequiredUI={createNewTerminalMode}
          />
          <DivColumn className="terminal-4-frame-8" style={{ width: "6.1rem" }}>
            <ParagraphText className="terminal-text-14">{ConstantsTexts.CODE_8}</ParagraphText>
            <ParagraphText className="terminal-text-33">{getSecondaryMeasurePercentForDisplay(7)}</ParagraphText>
          </DivColumn>
          <WidgetIconFive iconProp={UtilsUnit.getGaugeImageSrc(nationalModelForTerminalData.municipalityPosition)} widthIconProp="4.9rem" heightIconProp="3rem" />
        </DivRow>
      </>
    );
  }

  function terminalApplicabilityDisplay() {
    const feasibilityScore =
      nationalModelForTerminalData.municipalityPosition ?? nationalModelForTerminalData.municipalityPositionMeasure;

    return (
      <>
        <GaugeUI
          numberText={feasibilityScore}
          label={ConstantsTexts.CODE_8}
          percentLabel={getSecondaryMeasurePercentForDisplay(7)}
          widthTexts="6.1rem"
          previousValue={hasPendingFeasibilityChanged() ? getPendingFeasibilityBefore() : null}
          highlight={hasPendingFeasibilityChanged()}
        />
      </>
    );
  }

  function terminalCostsSection() {
    return (
      <div className="terminal-6-frame">
        <DivColumn className="terminal-6-frame-2">
          <DivRow className="terminal-4-frame-2">
            <WidgetIconFive iconProp={ConstantsImages.COINS_IMAGE} widthIconProp="2.7rem" heightIconProp="2.9rem" />
            <ParagraphText className="terminal-text-12">{ConstantsTexts.CODE_5}</ParagraphText>
          </DivRow>
          <DivColumn className="terminal-6-frame-3">
            <DivRow className="terminal-6-frame-4">
              <GaugeUI
                numberText={nationalModelForTerminalData.costPerTripMeasure}
                label={ConstantsTexts.CODE_26}
                percentLabel={getSecondaryMeasurePercentForDisplay(6)}
                widthTexts="31.6rem"
              />
              <GaugeUI
                numberText={nationalModelForTerminalData.costPerPassengerMeasure}
                label={ConstantsTexts.CODE_25}
                percentLabel={getSecondaryMeasurePercentForDisplay(5)}
                widthTexts="31.6rem"
              />
            </DivRow>
            <DivColumn className="terminal-6-frame-5">
              <DivRow className="terminal-6-frame-6">{editMode ? terminalStrategicRingEdit() : terminalStrategicRingDisplay()}</DivRow>
            </DivColumn>
          </DivColumn>
        </DivColumn>
      </div>
    );
  }

  function terminalStrategicRingEdit() {
    return (
      <>
        <div className="terminal-4-frame-13" style={{ height: "5.2rem", width: "14.5rem" }}>
          <WidgetDropdown
            options={numbers1To4}
            labelKey="number"
            title={ConstantsTexts.CODE_58}
            onSelect={handleSelectRingByStrategicPlan}
            selectedOptionProp={selectedRingByStrategicPlan}
            heightProp="4.4rem"
            widthProp="auto"
            backgroundColorProp="#E9EAEE"
            titleColorProp="#5A81FA"
            textColorProp="#2B308B"
            arrowImage={ConstantsImages.ARROW_SMALL_IMAGE}
            borderRadiusProp="1rem"
            fontSizeTitle="1.2rem"
            fontWeightText="800"
            fontFamilyText="Montserrat"
            disabled={isEditorEditingInitialVersion() || isEditingExistingTerminal()}
            enableClear={true}
            onClear={handleClearRingByStrategicPlan}
            isRequiredUI={createNewTerminalMode}
          />
        </div>
      </>
    );
  }

  function terminalStrategicRingDisplay() {
    return (
      <>
        <WidgetTextViewDataTerminalInfo title={ConstantsTexts.CODE_58} text={nationalModelForTerminalData.ringByStrategicPlan} widthProp="14.5rem" />
      </>
    );
  }

  function GaugeUI({
    numberText,
    label,
    percentLabel,
    widthTexts = "7rem",
    previousValue = null,
    highlight = false,
    showPreviousWhenSet = false,
  }) {
    return (
      <DivRow className={`terminal-4-frame-6${highlight ? " terminal-change-highlight" : ""}`}>
        <WidgetGaugeUI
          numberText={numberText}
          sizeProp="5.2rem"
          textSizeProp="2.8rem"
          isEmptyData={createNewTerminalMode}
          previousValue={previousValue}
          showPreviousWhenSet={showPreviousWhenSet}
        />
        <DivColumn className="terminal-4-frame-8" style={{ width: widthTexts }}>
          <ParagraphText className="terminal-text-14">{label}</ParagraphText>
          <ParagraphText className="terminal-text-33">{percentLabel}</ParagraphText>
        </DivColumn>
        <WidgetIconFive
          iconProp={createNewTerminalMode ? ConstantsImages.GAUGE_EMPTY_IMAGE : UtilsUnit.getGaugeImageSrc(numberText)}
          widthIconProp="4.9rem"
          heightIconProp="3rem"
        />
      </DivRow>
    );
  }

  function GaugeTerminalUI({
    numberText,
    terminalLabel,
    terminalPercentLabel,
    gaugeTitle,
    gaugeText,
    fontFamilyProp,
    previousValue = null,
    highlight = false,
    showPreviousWhenSet = false,
  }) {
    return (
      <DivColumn className="terminal-4-frame-5">
        <GaugeUI
          numberText={numberText}
          label={terminalLabel}
          percentLabel={terminalPercentLabel}
          previousValue={previousValue}
          highlight={highlight}
          showPreviousWhenSet={showPreviousWhenSet}
        />
        <WidgetTextViewDataTerminalInfo title={gaugeTitle} text={gaugeText} fontFamilyProp={fontFamilyProp} />
      </DivColumn>
    );
  }

  function WidgetTextViewDataTerminalInfo({ title, text, heightProp, widthProp, fontFamilyProp }) {
    return <WidgetTextViewData title={title} text={text} heightProp={heightProp} widthProp={widthProp} colorProp={colorEditMode} fontFamilyProp={fontFamilyProp} />;
  }

  function mapUi() {
    return (
      <div style={{ display: "flex", position: "relative" }}>
        <WidgetTerminalInfoMap
          heightProp="90.4rem"
          widthProp="82rem" // 73.8rem
          markers={terminalStops}
          nationalModelForTerminalData={nationalModelForTerminalData}
          selectedBusLinesData={getSelectedBusLinesData()}
          uploadedPolygon={uploadedPolygon}
        />
        {busLinesPanel()}
      </div>
    );
  }

  function busLinesPanel() {
    return (
      <div className="terminal-10-frame" style={{ position: "absolute", top: "6.3rem", left: "3.1rem" }}>
        {busLinesToggle()}
        {busLinesList()}
      </div>
    );
  }

  function busLinesToggle() {
    return (
      <div onClick={handleBusLinesMenuOpened}>
        {busLinesMenuOpened ? (
          <DivColumn className="terminal-10-frame-3">
            <WidgetIconFive iconProp={ConstantsImages.CLOSE_3_IMAGE} widthIconProp="1.1rem" heightIconProp="1.1rem" />
          </DivColumn>
        ) : (
          <DivColumn className="terminal-10-frame-2">
            <WidgetIconFive iconProp={ConstantsImages.LINES_IMAGE} widthIconProp="4rem" heightIconProp="2.9rem" />
            <ParagraphText className="terminal-text-36">{ConstantsTexts.CODE_126}</ParagraphText>
          </DivColumn>
        )}
      </div>
    );
  }

  function busLinesList() {
    return (
      busLinesMenuOpened && (
        <DivColumn className="terminal-10-frame-4">
          <DivColumn className="terminal-10-frame-5">
            {busLinesGroup(
              ConstantsTexts.CODE_127,
              busLinesInTerminalItems,
              busLinesInTerminalExpanded,
              handleBusLinesInTerminalExpanded,
              busLinesInTerminalChecked,
              handleBusLinesInTerminalChecked,
              handleTerminalItemCheck,
            )}
            {busLinesGroup(
              ConstantsTexts.CODE_128,
              busLinesNearTerminalItems,
              busLinesNearTerminalExpanded,
              handleBusLinesNearTerminalExpanded,
              busLinesNearTerminalChecked,
              handleBusLinesNearTerminalChecked,
              handleNearTerminalItemCheck,
            )}
          </DivColumn>
        </DivColumn>
      )
    );
  }

  // Renders collapsible bus lines group with master checkbox and virtualized list for performance
  function busLinesGroup(title, busLines, expanded, handleExpanded, checked, handleChecked, onItemCheck) {
    const Row = ({ index, style }) => {
      const item = busLines[index];
      return (
        <div style={{ ...style }}>
          <DivRow key={item.RouteShortName} className="terminal-10-frame-8">
            <WidgetCheckbox checked={item.checked} onChange={() => onItemCheck(index)} />
            <WidgetIconThree iconProp={ConstantsImages.BUS_ROUTE_IMAGE} colorProp={item.color} widthIconProp="1.8rem" heightIconProp="1.8rem" />
            <ParagraphText className={item.checked ? "terminal-text-39-selected" : "terminal-text-39-unselected"}>{item.RouteShortName}</ParagraphText>
            <ParagraphText className={item.checked ? "terminal-text-40-selected" : "terminal-text-40-unselected"}>{item.FormattedRouteName}</ParagraphText>
          </DivRow>
        </div>
      );
    };

    return (
      <DivColumn className="terminal-10-frame-6">
        <DivRow className="terminal-10-frame-7">
          <ParagraphText className="terminal-text-38" onClick={handleExpanded}>
            {expanded ? "-" : "+"}
          </ParagraphText>
          <WidgetCheckbox checked={checked} onChange={handleChecked} />
          <ParagraphText className={checked ? "terminal-text-37" : "terminal-text-40-unselected"}>{title}</ParagraphText>
        </DivRow>
        {expanded && (
          <div className="terminal-10-frame-9" style={{ width: "100%" }}>
            <WidgetFixedSizeList height={25} itemCount={busLines.length} itemSize={4}>
              {Row}
            </WidgetFixedSizeList>
          </div>
        )}
      </DivColumn>
    );
  }

  function commentsSection() {
    return editMode ? commentsEditMode() : commentsDisplayMode();
  }

  function commentsEditMode() {
    return (
      <div className="terminal-8-frame-15">
        <div className="terminal-8-frame-16">
          <DivColumn className="terminal-8-frame-17">
            <ParagraphText className="terminal-text-30">{ConstantsTexts.CODE_37}</ParagraphText>
            <InputTwo value={inputValueComments} onChange={handleChangeComments} disabled={shouldShowFieldsForGeneral()} />
          </DivColumn>
        </div>
      </div>
    );
  }

  function commentsDisplayMode() {
    return (
      <DivRow className="terminal-8-frame">
        <WidgetIconFive iconProp={ConstantsImages.COMMENTS_IMAGE} widthIconProp="1.6rem" heightIconProp="1.6rem" />
        <ParagraphText className="terminal-text-20">{nationalModelForTerminalData.comments}</ParagraphText>
      </DivRow>
    );
  }

  function alertDialog() {
    return (
      <>
        {isDialogEditOpen && (
          <WidgetAlertDialogEdit
            onApprove={() => closeEditAlertDialog(true)}
            onCancel={() => closeEditAlertDialog(false)}
            messageText={getDialogEditMessageText()}
            approveText={getDialogEditApproveText()}
            cancelText={getDialogEditCancelText()}
            actionType={lastActionRef?.current}
          />
        )}
        {isFrozenTerminalBlockedDialogOpen && (
          <WidgetAlertDialogFrozenTerminalBlocked onClose={closeFrozenTerminalBlockedDialog} />
        )}
        {isOpenChangeRequestBlockedDialogOpen && (
          <WidgetAlertDialogOpenChangeRequestBlocked
            terminalName={getOpenChangeRequestBlockedTerminalName()}
            onClose={closeOpenChangeRequestBlockedDialog}
          />
        )}
        {isSubjectiveChangeReasonDialogOpen && (
          <WidgetAlertDialogSubjectiveChangeReason
            onCancel={closeSubjectiveChangeReasonDialog}
            onApprove={submitSubjectiveChangeRequest}
          />
        )}
        {isSubjectiveChangeSuccessDialogOpen && (
          <WidgetAlertDialogSubjectiveChangeSuccess
            onClose={closeSubjectiveChangeSuccessDialog}
            messageText={getSubjectiveChangeSuccessMessage()}
            checkIconProp={
              subjectiveChangeSuccessKind === "approve"
                ? ConstantsImages.CHANGE_REQUEST_APPROVED_CHECK_IMAGE
                : subjectiveChangeSuccessKind === "reject"
                  ? ConstantsImages.CHANGE_REQUEST_REJECTED_ICON_IMAGE
                  : undefined
            }
            iconSize={subjectiveChangeSuccessKind === "reject" ? "2.8rem" : "2.7rem"}
          />
        )}
        {isChangeRequestDetailsOpen && (
          <WidgetAlertDialogChangeRequestDetails
            changeRequest={pendingChangeRequest}
            onClose={closeChangeRequestDetails}
            onApprove={approvePendingChangeRequest}
            onReject={rejectPendingChangeRequest}
            isApproving={isApprovingChangeRequest}
            isRejecting={isRejectingChangeRequest}
          />
        )}
      </>
    );
  }
}

export default PageTerminalInfo;
